<div class="radio-button-dropdown-container" [ngClass]="[containerCss, attrDisable ? 'disabled' : '']">
  <ng-container *ngIf="!labelInside" [ngTemplateOutlet]="labelTemplate"></ng-container>
  <div
    class="radio-button-dropdown-content display-flex align-items-center w-100"
    [ngClass]="[
      markAsInvalid || (errors && showValidationErrorOrSubmitted) ? 'invalid' : '',
      attrDisable ? 'disabled' : '',
      !activeOnFocus && hasValue && !(attrDisable || _listLoading) && highlightWhenActive ? 'active' : '',
      activeOnFocus && _focused && highlightWhenActive ? 'active' : ''
    ]"
  >
    <ng-container *ngIf="labelInside" [ngTemplateOutlet]="labelTemplate"></ng-container>
    <mat-spinner *ngIf="_listLoading" class="ml-4" color="accent" diameter="20"></mat-spinner>
    <ng-select
      #ngSelect
      class="select-container flex-1"
      [formControl]="control"
      [ngClass]="[selectCss, containerWidthCss]"
      [ngStyle]="{
        'padding-left': labelInside ? labelWidth : 'initial',
        'margin-left': labelInside ? '-' + labelWidth : 'initial'
      }"
      [closeOnSelect]="!multiSelect"
      [multiple]="multiSelect"
      [searchable]="allowSearch"
      [clearable]="allowClear"
      [placeholder]="attrPlaceholder"
      [bindLabel]="'label'"
      [bindValue]="'value'"
      [readonly]="attrDisable || _listLoading"
      (change)="onChanged($event)"
      [appendTo]="attrAppendTo"
      [searchFn]="searchFunction.bind(this)"
      (focusin)="_focused = true"
      (focusout)="_focused = false"
    >
      <ng-container *ngIf="allowSelectAll">
        <ng-template ng-header-tmp>
          <div>
            <a href="javascript:void(0)" (click)="onSelectAll()">Select All</a>
            &nbsp;&nbsp;
            <a href="javascript:void(0)" (click)="onClearAll()">Clear All</a>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="allowAddNew">
        <ng-template ng-footer-tmp>
          <a class="no-underline" href="javascript:void(0)" (click)="onAddNew()">{{ addNewLabel }}</a>
        </ng-template>
      </ng-container>

      <ng-template ng-label-tmp>
        <div class="display-flex grid-gap-8 align-items-center" [ngClass]="valueCss">
          {{ displayValue | escapeHtml }}
        </div>
      </ng-template>

      <ng-template ng-multi-label-tmp>
        <div class="display-flex grid-gap-8 align-items-center" [ngClass]="valueCss">
          {{ displayValue }}
        </div>
      </ng-template>

      <ng-container
        [ngTemplateOutlet]="controlSectionItems?.length ? separatorListListTemplate : defaultListTemplate"
        [ngTemplateOutletContext]="{ itemList: controlItems }"
      ></ng-container>

      <ng-template #defaultListTemplate let-itemList="itemList" let-showSeparator="showSeparator">
        <ng-option *ngFor="let item of itemList" [ngClass]="optionCss" [value]="item.value" [disabled]="item.disabled">
          <div class="display-flex grid-gap-8 align-items-center option-container">
            <div class="checkbox-icon"></div>
            <ng-container
              [ngTemplateOutlet]="customListItemTemplate || defaultListItemTemplate"
              [ngTemplateOutletContext]="{ item: item }"
            ></ng-container>
          </div>
        </ng-option>
        <ng-option [ngClass]="optionCss" disabled="disabled" *ngIf="showSeparator">
          <mat-divider></mat-divider>
        </ng-option>
      </ng-template>

      <ng-template #separatorListListTemplate>
        <ng-container *ngFor="let item of controlSectionItems; let last = last">
          <ng-container
            [ngTemplateOutlet]="defaultListTemplate"
            [ngTemplateOutletContext]="{ itemList: item, showSeparator: !last }"
          ></ng-container>
        </ng-container>
      </ng-template>
    </ng-select>
  </div>
  <app-input-error
    *ngIf="errorSection && errors"
    [errors]="errors"
    [visible]="markAsInvalid || (errors && showValidationErrorOrSubmitted)"
  ></app-input-error>
</div>

<ng-template #labelTemplate>
  <div #labelElement class="label-container" *ngIf="label || icon">
    <label
      class="dropdown-label"
      [ngClass]="[
        labelCss,
        labelInside ? 'inside' : '',
        attrDisable ? 'disable' : '',
        labelRequired ? 'label-required' : ''
      ]"
      [matTooltip]="labelTooltip"
      *ngIf="label"
    >
      {{ label }}
    </label>
    <app-icon
      [ngClass]="iconCss"
      [matTooltip]="iconTooltip"
      *ngIf="icon"
      [svg]="icon"
      [iconHeight]="24"
      [iconWidth]="24"
    ></app-icon>
  </div>
</ng-template>

<ng-template #defaultListItemTemplate let-item="item">
  <div
    [attr.data-label]="labelInside"
    [ngClass]="[optionCss, !labelInside ? 'ml' : '', attrDisable ? 'disable' : '']"
    [innerHTML]="item.label | escapeHtml"
    [title]="item.label | escapeHtml"
  ></div>
</ng-template>
